import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

export default function Stages() {
  return (
    <>
      <Header />
      <h1>ЗДЕСЬ БУДУТ ЭТАПЫ</h1>
      <Footer />
    </>
  );
}
